import AdminMenus from "@/views/admin/menus/Menus";

export default {
  path: "menus/cartas",
  name: "menus",
  component: AdminMenus,
  props: true,
  meta: {
    requiresAuth: true
  }
};
